<script setup lang="ts">
  import { fmt } from '@/functions'
  import { getOrderStatus } from '@/models/shop-order'
  import SearchResultGroup from './search-result-group.vue'

  defineProps<{
    orders: SearchOrder[],
  }>()
</script>

<template>
  <search-result-group
    v-slot="{ item: order }"
    :items="orders"
    route-list="shop order list"
    route-detail="shop order detail"
    name="Pesanan">
    <div class="text-sm font-medium">
      {{ order.invoice_number }}
    </div>

    <app-badge
      class="mb-2"
      size="sm"
      :variant="getOrderStatus(order.order_status).variant">
      {{ getOrderStatus(order.order_status).label }}
    </app-badge>
    <div class="flex items-center text-xs gap-1.5">
      <div class="text-gray-500 mt-1">
        <fa-icon icon="i-far-money-bill" />
      </div>
      <div>Rp {{ fmt.number(order.grand_total) }}</div>
    </div>
    <div class="flex items-center text-xs gap-1.5">
      <div class="text-gray-500 mt-1">
        <fa-icon icon="i-far-calendar" />
      </div>
      <div>{{ fmt.dateForm(order.created_at) }}</div>
    </div>
  </search-result-group>
</template>
